import React from 'react';

import Header from '../../../../Layout/Header';
import FooterComponent from '../../../../Layout/Footer';
import banner from '../../../../Assets/Linkages/InternationalConferences/ICAST-Page-Banner.jpg';
import introductionImage from '../../../../Assets/Linkages/InternationalConferences/ICAST-Page-Introduction.png';
import tracksImage from '../../../../Assets/Linkages/InternationalConferences/ICAST-Tracks.png';
import highlightsImage from '../../../../Assets/Linkages/InternationalConferences/ICAST-Highlights.png';
import '../../../../Styles/Linkages&Outreach.css';
import '../../../../Styles/ICASTFeature.css';
import PartnersSponsors from './PartnersSponsors';
import ICASTGallery from './ICASTGallery';
import ICASTMediaImpression from './ICASTMediaImpression';

const ICASTPage = () => (
  <>
    <Header />
    <main className="icast-page">
      <section className="international-conferences-banner" aria-label="ICAST">
        <img
          src={banner}
          alt="International Conference on Applications of Space Science and Technology"
        />
      </section>
      <section className="international-conference-feature" aria-labelledby="icast-introduction-title">
        <div className="international-conference-feature-inner">
          <figure className="international-conference-feature-image">
            <img
              src={introductionImage}
              alt="International Conference on Applications of Space Science and Technology"
              loading="lazy"
            />
          </figure>
          <div className="international-conference-feature-copy">
            <p className="section-eyebrow">ABOUT THE CONFERENCE</p>
            <h1 id="icast-introduction-title">Introduction</h1>
            <div className="world-space-week-title-line" aria-hidden="true" />
            <p>
              The International Conference on Applications of Space Science and Technology (ICAST)
              marks a transformative milestone in Pakistan’s journey through space science and
              technology. As the largest space event in the country, ICAST unites the legacies of
              IST’s International Conference on Aerospace Science and Engineering (ICASE) and
              SUPARCO’s International Conference on Space (ICS) into a biennial global forum of
              unparalleled excellence.
            </p>
            <p>
              Bringing together visionaries, global thought leaders, pioneering researchers, and
              industry trailblazers, ICAST aspires to redefine the future of space science by
              fostering collaboration, presenting transformative research, and exploring
              interdisciplinary space applications with the potential to reshape our collective future.
            </p>
            <a
              className="outreach-film-trailer-link"
              href="https://icast.pk/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Visit ICAST Website <span aria-hidden="true">↗</span>
            </a>
          </div>
        </div>
      </section>
      <section className="icast-theme-section" aria-labelledby="icast-theme-title">
        <div className="icast-theme-inner">
          <p className="section-eyebrow">SPACE FOR SUSTAINABLE DEVELOPMENT</p>
          <h2 id="icast-theme-title">ICAST Theme</h2>
          <div className="world-space-week-title-line" aria-hidden="true" />
          <p>
            The theme of ICAST 2025, <strong>“Space for Sustainable Development”</strong>, highlights
            the vital role of space science and technology in addressing global challenges such as
            climate change, resource scarcity, and urban expansion. In line with Pakistan’s vision
            for societal progress, the conference provides a platform to explore space-based
            innovations, technologies, and applications that advance the UN Sustainable Development
            Goals and promote cross-sector collaboration for a more resilient future.
          </p>
        </div>
      </section>
      <section className="icast-tracks-section" aria-labelledby="icast-tracks-title">
        <div className="icast-tracks-inner">
          <div className="icast-tracks-copy">
            <p className="section-eyebrow">EXPLORE THE CONFERENCE</p>
            <h2 id="icast-tracks-title">Tracks</h2>
            <div className="world-space-week-title-line" aria-hidden="true" />
            <p>
              The tracks of ICAST 2025 are designed to encompass the vast and ever-expanding universe
              of space science and technology, from foundational research to cutting-edge advancements
              that are redefining humanity’s exploration of the cosmos. Each track serves as a gateway
              to delve into interdisciplinary innovation, fostering collaborations that bridge gaps
              between theory, application, and policy.
            </p>
            <a
              className="outreach-film-trailer-link"
              href="https://icast.pk/tracks"
              target="_blank"
              rel="noopener noreferrer"
            >
              Theme &amp; Tracks <span aria-hidden="true">→</span>
            </a>
          </div>
          <figure className="icast-tracks-image">
            <img src={tracksImage} alt="ICAST 2025 conference tracks" loading="lazy" />
          </figure>
        </div>
      </section>
      <section className="icast-publications-section" aria-labelledby="icast-publications-title">
        <div className="icast-publications-inner">
          <p className="section-eyebrow">KNOWLEDGE &amp; PROCEEDINGS</p>
          <h2 id="icast-publications-title">Conference Publications</h2>
          <div className="world-space-week-title-line" aria-hidden="true" />
          <a
            className="icast-publication-card"
            href="https://icast.pk/PDF/ICAST%202025%20-%20Conference%20Program.pdf"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open the ICAST 2025 conference program PDF"
          >
            <span className="icast-publication-icon" aria-hidden="true">
              <span>PDF</span>
            </span>
            <span className="icast-publication-content">
              <span className="icast-publication-meta">ICAST 2025 · OFFICIAL PUBLICATION</span>
              <strong>Conference Program</strong>
              <span>View the complete conference schedule, sessions, and program details.</span>
            </span>
            <span className="icast-publication-action">
              Open Publication <span aria-hidden="true">↗</span>
            </span>
          </a>
        </div>
      </section>
      <section className="icast-highlights-section" aria-labelledby="icast-highlights-title">
        <div className="icast-highlights-inner">
          <div className="icast-highlights-copy">
            <p className="section-eyebrow">ICAST 2025 AT A GLANCE</p>
            <h2 id="icast-highlights-title">Conference Highlights</h2>
            <div className="world-space-week-title-line" aria-hidden="true" />
            <p>
              ICAST 2025 featured a diverse range of activities designed to promote knowledge
              sharing, global collaboration, and interactive learning in the applications of space
              science and technology. The following are the conference highlights.
            </p>
            <a
              className="outreach-film-trailer-link"
              href="https://icast.pk/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Visit ICAST Website <span aria-hidden="true">↗</span>
            </a>
          </div>
          <figure className="icast-highlights-image">
            <img src={highlightsImage} alt="ICAST 2025 conference highlights" loading="lazy" />
          </figure>
        </div>
      </section>
      <PartnersSponsors />
      <ICASTMediaImpression/>
      <ICASTGallery />
    </main>
    <FooterComponent />
  </>
);

export default ICASTPage;
